export default __webpack_public_path__ + "static/Quickinstallation_IN-6001_09-af2e9115380998c67dc78d9b04acfa10.webp";